import {type Dispatch, type RefObject, type SetStateAction, useCallback, useEffect, useMemo, useRef, useState} from "react";
import {useSelector, useStore} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";

type SidebarPositionMode = "before-section" | "fixed" | "after-section";

type Params = {
    sectionRef: RefObject<HTMLElement | null>;
    // Open/closed state is owned by the parent (OfferListView) so the listing can drop the reserved
    // sidebar column when the advisor is collapsed. Both share a single source of truth.
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
};

type Result = {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    shellRef: RefObject<HTMLDivElement | null>;
    sidebarPanelRef: RefObject<HTMLDivElement | null>;
    scrollContainerRef: RefObject<HTMLDivElement | null>;
    mode: SidebarPositionMode;
    shellStyle: {zIndex: number};
    isAuthOverlayOpen: boolean;
};

/**
 * Handles FloatingSemanticSearchSidebar runtime behavior:
 * - open/close state (owned by the parent, passed in via params),
 * - sticky/fixed/absolute position mode switching based on scroll,
 * - dynamic top/height updates applied directly to DOM refs,
 * - lock flag for sidebar content when auth overlay is open.
 */
export const useFloatingSemanticSearchSidebarBehavior = (params: Params): Result => {
    const {sectionRef, isOpen, setIsOpen} = params;
    const [mode, setMode] = useState<SidebarPositionMode>("before-section");
    const store = useStore<IRPStore>();
    const modeRef = useRef<SidebarPositionMode>("before-section");
    const topOffsetPxRef = useRef(0);
    const heightPxRef = useRef(0);
    const absoluteTopPxRef = useRef(0);
    const appliedHeightPxRef = useRef<number | null>(null);
    const appliedTopPxRef = useRef<number | null>(null);
    const rafIdRef = useRef<number | null>(null);

    const shellRef = useRef<HTMLDivElement>(null);
    const sidebarPanelRef = useRef<HTMLDivElement>(null);
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const isAuthOverlayOpen = useSelector((state: IRPStore) => state.semanticSearchAuth.activeDrawer !== null);

    const applyDynamicStyles = useCallback(() => {
        const shellEl = shellRef.current;

        if (!shellEl) return;

        const nextHeightPx = Math.max(0, heightPxRef.current);
        if (appliedHeightPxRef.current !== nextHeightPx) {
            shellEl.style.height = `${nextHeightPx}px`;
            appliedHeightPxRef.current = nextHeightPx;
        }

        let nextTopPx = 0;

        if (modeRef.current === "fixed") {
            nextTopPx = topOffsetPxRef.current;
        } else if (modeRef.current === "after-section") {
            nextTopPx = absoluteTopPxRef.current;
        }

        if (appliedTopPxRef.current !== nextTopPx) {
            shellEl.style.top = `${nextTopPx}px`;
            appliedTopPxRef.current = nextTopPx;
        }
    }, []);

    useEffect(() => {
        const updatePosition = () => {
            const sectionEl = sectionRef.current;

            if (!sectionEl) return;

            const rect = sectionEl.getBoundingClientRect();
            const sectionTop = window.scrollY + rect.top;
            const sectionHeight = sectionEl.offsetHeight;
            const sectionBottom = sectionTop + sectionHeight;
            const viewportHeight = window.innerHeight;
            const scrollTop = window.scrollY;
            const {stickyHeaderVisibility, stickyHeaderCurrentHeight} = store.getState().offerListing;
            const fixedStart = sectionTop;
            const fixedEnd = sectionBottom - viewportHeight;
            const stickyHeaderOffset = stickyHeaderVisibility === 1 ? stickyHeaderCurrentHeight : 0;

            let nextMode: SidebarPositionMode = "after-section";

            if (scrollTop < fixedStart) {
                nextMode = "before-section";
            } else if (scrollTop <= fixedEnd) {
                nextMode = "fixed";
            }

            const sectionViewportOffset = nextMode === "fixed" ? 0 : Math.max(0, rect.top);
            const topOffset = Math.round(sectionViewportOffset + stickyHeaderOffset);
            const height = Math.round(viewportHeight - topOffset);
            const nextAbsoluteTop = Math.round(Math.max(sectionHeight - Math.max(0, height), 0));

            topOffsetPxRef.current = topOffset;
            heightPxRef.current = height;
            absoluteTopPxRef.current = nextAbsoluteTop;

            if (modeRef.current !== nextMode) {
                modeRef.current = nextMode;
                setMode(nextMode);
            }

            applyDynamicStyles();
        };

        const scheduleUpdate = () => {
            if (rafIdRef.current !== null) return;

            rafIdRef.current = requestAnimationFrame(() => {
                updatePosition();
                rafIdRef.current = null;
            });
        };

        scheduleUpdate();

        window.addEventListener("scroll", scheduleUpdate, {passive: true});
        window.addEventListener("resize", scheduleUpdate);

        return () => {
            window.removeEventListener("scroll", scheduleUpdate);
            window.removeEventListener("resize", scheduleUpdate);
            if (rafIdRef.current !== null) {
                cancelAnimationFrame(rafIdRef.current);
                rafIdRef.current = null;
            }
        };
    }, [sectionRef, store, applyDynamicStyles]);

    const shellStyle = useMemo(() => ({zIndex: mode === "fixed" ? 50 : 20}), [mode]);

    return {
        isOpen,
        setIsOpen,
        shellRef,
        sidebarPanelRef,
        scrollContainerRef,
        mode,
        shellStyle,
        isAuthOverlayOpen
    };
};
import {type Dispatch, type RefObject, type SetStateAction, useCallback, useEffect, useMemo, useRef, useState} from "react";
import {useSelector, useStore} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";

type SidebarPositionMode = "before-section" | "fixed" | "after-section";

type Params = {
    sectionRef: RefObject<HTMLElement | null>;
    // Open/closed state is owned by the parent (OfferListView) so the listing can drop the reserved
    // sidebar column when the advisor is collapsed. Both share a single source of truth.
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
};

type Result = {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    shellRef: RefObject<HTMLDivElement | null>;
    sidebarPanelRef: RefObject<HTMLDivElement | null>;
    scrollContainerRef: RefObject<HTMLDivElement | null>;
    mode: SidebarPositionMode;
    shellStyle: {zIndex: number};
    isAuthOverlayOpen: boolean;
};

/**
 * Handles FloatingSemanticSearchSidebar runtime behavior:
 * - open/close state (owned by the parent, passed in via params),
 * - sticky/fixed/absolute position mode switching based on scroll,
 * - dynamic top/height updates applied directly to DOM refs,
 * - lock flag for sidebar content when auth overlay is open.
 */
export const useFloatingSemanticSearchSidebarBehavior = (params: Params): Result => {
    const {sectionRef, isOpen, setIsOpen} = params;
    const [mode, setMode] = useState<SidebarPositionMode>("before-section");
    const store = useStore<IRPStore>();
    const modeRef = useRef<SidebarPositionMode>("before-section");
    const topOffsetPxRef = useRef(0);
    const heightPxRef = useRef(0);
    const absoluteTopPxRef = useRef(0);
    const appliedHeightPxRef = useRef<number | null>(null);
    const appliedTopPxRef = useRef<number | null>(null);
    const rafIdRef = useRef<number | null>(null);

    const shellRef = useRef<HTMLDivElement>(null);
    const sidebarPanelRef = useRef<HTMLDivElement>(null);
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const isAuthOverlayOpen = useSelector((state: IRPStore) => state.semanticSearchAuth.activeDrawer !== null);

    const applyDynamicStyles = useCallback(() => {
        const shellEl = shellRef.current;

        if (!shellEl) return;

        const nextHeightPx = Math.max(0, heightPxRef.current);
        if (appliedHeightPxRef.current !== nextHeightPx) {
            shellEl.style.height = `${nextHeightPx}px`;
            appliedHeightPxRef.current = nextHeightPx;
        }

        let nextTopPx = 0;

        if (modeRef.current === "fixed") {
            nextTopPx = topOffsetPxRef.current;
        } else if (modeRef.current === "after-section") {
            nextTopPx = absoluteTopPxRef.current;
        }

        if (appliedTopPxRef.current !== nextTopPx) {
            shellEl.style.top = `${nextTopPx}px`;
            appliedTopPxRef.current = nextTopPx;
        }
    }, []);

    useEffect(() => {
        const updatePosition = () => {
            const sectionEl = sectionRef.current;

            if (!sectionEl) return;

            const rect = sectionEl.getBoundingClientRect();
            const sectionTop = window.scrollY + rect.top;
            const sectionHeight = sectionEl.offsetHeight;
            const sectionBottom = sectionTop + sectionHeight;
            const viewportHeight = window.innerHeight;
            const scrollTop = window.scrollY;
            const {stickyHeaderVisibility, stickyHeaderCurrentHeight} = store.getState().offerListing;
            const fixedStart = sectionTop;
            const fixedEnd = sectionBottom - viewportHeight;
            const stickyHeaderOffset = stickyHeaderVisibility === 1 ? stickyHeaderCurrentHeight : 0;

            let nextMode: SidebarPositionMode = "after-section";

            if (scrollTop < fixedStart) {
                nextMode = "before-section";
            } else if (scrollTop <= fixedEnd) {
                nextMode = "fixed";
            }

            const sectionViewportOffset = nextMode === "fixed" ? 0 : Math.max(0, rect.top);
            const topOffset = Math.round(sectionViewportOffset + stickyHeaderOffset);
            const height = Math.round(viewportHeight - topOffset);
            const nextAbsoluteTop = Math.round(Math.max(sectionHeight - Math.max(0, height), 0));

            topOffsetPxRef.current = topOffset;
            heightPxRef.current = height;
            absoluteTopPxRef.current = nextAbsoluteTop;

            if (modeRef.current !== nextMode) {
                modeRef.current = nextMode;
                setMode(nextMode);
            }

            applyDynamicStyles();
        };

        const scheduleUpdate = () => {
            if (rafIdRef.current !== null) return;

            rafIdRef.current = requestAnimationFrame(() => {
                updatePosition();
                rafIdRef.current = null;
            });
        };

        scheduleUpdate();

        window.addEventListener("scroll", scheduleUpdate, {passive: true});
        window.addEventListener("resize", scheduleUpdate);

        return () => {
            window.removeEventListener("scroll", scheduleUpdate);
            window.removeEventListener("resize", scheduleUpdate);
            if (rafIdRef.current !== null) {
                cancelAnimationFrame(rafIdRef.current);
                rafIdRef.current = null;
            }
        };
    }, [sectionRef, store, applyDynamicStyles]);

    const shellStyle = useMemo(() => ({zIndex: mode === "fixed" ? 50 : 20}), [mode]);

    return {
        isOpen,
        setIsOpen,
        shellRef,
        sidebarPanelRef,
        scrollContainerRef,
        mode,
        shellStyle,
        isAuthOverlayOpen
    };
};
